import { render, staticRenderFns } from "./TeamBiodata.vue?vue&type=template&id=2d509345"
import script from "./TeamBiodata.vue?vue&type=script&lang=js"
export * from "./TeamBiodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports